(function () {
  const PROPERTY_KEY = "_fm_delivery_mode";
  const SKU_KEY = "_sku";

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load cart.js");
    return await res.json();
  }

  async function changeLine(line, properties) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ line, properties }),
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`cart/change.js failed: ${res.status} ${txt}`);
    }
    return await res.json();
  }

  async function init(root) {
    // prevent double-binding if init runs multiple times
    if (root.dataset.fmInit === "1") return;
    root.dataset.fmInit = "1";

    const statusEl = root.querySelector("[data-fm-status]");
    const radios = Array.from(root.querySelectorAll('input[name="fm_delivery_mode"]'));

    const setStatus = (msg) => { if (statusEl) statusEl.textContent = msg || ""; };
    const getSelectedValue = () => (radios.find(r => r.checked)?.value ?? null);
    const setSelectedValue = (val) => radios.forEach(r => (r.checked = r.value === val));

    async function applyModeToAllLines(mode) {
      setStatus("Saving delivery type…");

      const cart = await getCart();
      if (!cart.items || cart.items.length === 0) {
        setStatus("Cart is empty.");
        return;
      }

      for (let i = 0; i < cart.items.length; i++) {
        const line = i + 1;
        const item = cart.items[i];
        const existing = item.properties || {};
        const sku = item.sku || null;
        const nextProps = { ...existing, [PROPERTY_KEY]: mode, ...(sku ? {[SKU_KEY]: sku} : {}),  };
        await changeLine(line, nextProps);
      }

      setStatus("Saved. Rates will reflect this at checkout.");
    }

    // preload selection from first line if present
    try {
      const cart = await getCart();
      const existingMode = cart.items?.[0]?.properties?.[PROPERTY_KEY];
      if (existingMode) setSelectedValue(existingMode);
    } catch {}

    radios.forEach(radio => {
      radio.addEventListener("change", async () => {
        const mode = getSelectedValue();
        if (!mode) return;
        try {
          await applyModeToAllLines(mode);
        } catch (e) {
          console.error("[freightmate] failed to set delivery mode", e);
          setStatus("Could not save selection. Please try again.");
        }
      });
    });
  }

  function scanAndInit() {
    document.querySelectorAll("[data-fm-delivery-mode]").forEach(init);
  }

  // Run now (covers normal full page loads)
  scanAndInit();

  // Run when Shopify sections are dynamically loaded
  document.addEventListener("shopify:section:load", scanAndInit);
  document.addEventListener("shopify:section:reorder", scanAndInit);

  // Run when DOM is mutated (covers cart drawers / ajax renders)
  const mo = new MutationObserver(scanAndInit);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
